<template>
  <div>
    <HeaderReceipt header="แก้ไขรายละเอียดใบสั่งซื้อ" :img_header="header_image" link_back="stock/storage/addproducttostock"/>
    <StoragePO_edit/>
  </div>
</template>

<script>
import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt";
import HeaderImage from "@/assets/completed-task.png";
import StoragePO_edit from "@/components/admin/stock/po/StoragePO_edit";
export default {
  name: "PoEdit",
  data() {
    return {
      header_image: HeaderImage
    }
  },
  components: {
    StoragePO_edit,
    HeaderReceipt
  }
}
</script>

<style scoped>

</style>
